"use client"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig, VideoProps } from "./RenderConfig"

export const Video: ComponentConfig<VideoProps> = {
  label: "Tamda Foods | Video",
  fields: {
    linkVideo: {
      label: "Link Video",
      type: "text",
    },
    heightMobile: {
      label: "Height Mobile",
      type: "text",
    },
    heightDesktop: {
      label: "Height Desktop",
      type: "text",
    },
    borderRadius: {
      label: "Border Radius",
      type: "text",
    },
  },
  defaultProps: {
    heightDesktop: "721px",
    heightMobile: "189px",
  },
  ...RenderConfig,
}
